const $2ca1f701144f0151$export$34e0f9847d4c02dd = document.querySelector(".container");
const $2ca1f701144f0151$export$ebd67ae47355be27 = document.querySelector(".theme__toggle");
const $2ca1f701144f0151$export$5de1d99ba6724316 = document.querySelector(".todo__list");
const $2ca1f701144f0151$export$4af0d615ab358e1 = ()=>document.querySelectorAll(".todo__item");
const $2ca1f701144f0151$export$50ad14c9bc092f7 = document.querySelector(".todo__form");
const $2ca1f701144f0151$export$84c805134b84d573 = document.querySelector(".todo__input");
const $2ca1f701144f0151$export$1182a909c961e05a = ()=>document.querySelectorAll(".check__icon");
const $2ca1f701144f0151$export$867996ef69c16623 = ()=>document.querySelectorAll(".cross__icon");
const $2ca1f701144f0151$export$f5e68c38e9e5defa = document.querySelector(".filter__all");
const $2ca1f701144f0151$export$a23e3f5d5881010d = document.querySelector(".filter__active");
const $2ca1f701144f0151$export$b0d7066fd38865c3 = document.querySelector(".filter__completed");
const $2ca1f701144f0151$export$846bb1a464a67773 = document.querySelector(".clear__button");
const $2ca1f701144f0151$export$798c1b4704cda203 = document.querySelector(".left__count");




const $684d38222e3cd930$var$assignKeyDownEvent = (e)=>{
    if (e.key === "Enter" || e.key === " ") e.currentTarget.click();
};
(0, $2ca1f701144f0151$export$ebd67ae47355be27).addEventListener("click", ()=>{
    const isDarkTheme = JSON.parse((0, $14404445c989d616$export$7a171f172be0782e)("isDarkTheme"));
    (0, $14404445c989d616$export$15d8621db9a88346)("isDarkTheme", !isDarkTheme);
    (0, $14404445c989d616$export$f543642fc33c1018)();
});
(0, $2ca1f701144f0151$export$50ad14c9bc092f7).addEventListener("submit", (e)=>{
    e.preventDefault();
    let tasksList = JSON.parse((0, $14404445c989d616$export$7a171f172be0782e)("tasksList")) || [];
    let activeCount = JSON.parse((0, $14404445c989d616$export$7a171f172be0782e)("activeCount")) || 0;
    const task = {
        id: crypto.randomUUID(),
        value: (0, $2ca1f701144f0151$export$84c805134b84d573).value,
        isCompleted: false,
        hide: false,
        isDisplayAll: true,
        order: tasksList.length
    };
    const updatedList = (0, $14404445c989d616$export$1e81c9115b544420)(task, tasksList);
    (0, $14404445c989d616$export$15d8621db9a88346)("activeCount", activeCount + 1);
    (0, $14404445c989d616$export$9a6a8fa585914167)(updatedList);
    (0, $2ca1f701144f0151$export$84c805134b84d573).value = "";
    (0, $2ca1f701144f0151$export$f5e68c38e9e5defa).click();
});
const $684d38222e3cd930$var$completeEvents = ()=>{
    (0, $2ca1f701144f0151$export$1182a909c961e05a)().forEach((icon)=>{
        icon.addEventListener("click", (e)=>{
            let activeCount = JSON.parse((0, $14404445c989d616$export$7a171f172be0782e)("activeCount"));
            let completedCount = JSON.parse((0, $14404445c989d616$export$7a171f172be0782e)("completedCount"));
            const tasksList = JSON.parse((0, $14404445c989d616$export$7a171f172be0782e)("tasksList"));
            const targetTask = tasksList.find((task)=>task.id === e.currentTarget.dataset.id);
            if (targetTask.isCompleted) {
                (0, $14404445c989d616$export$15d8621db9a88346)("activeCount", activeCount + 1);
                (0, $14404445c989d616$export$15d8621db9a88346)("completedCount", completedCount - 1);
            } else {
                (0, $14404445c989d616$export$15d8621db9a88346)("activeCount", activeCount - 1);
                (0, $14404445c989d616$export$15d8621db9a88346)("completedCount", completedCount + 1);
            }
            targetTask.isCompleted = !targetTask.isCompleted;
            targetTask.hide = targetTask.isDisplayAll ? targetTask.hide : !targetTask.hide;
            (0, $14404445c989d616$export$15d8621db9a88346)("tasksList", tasksList);
            (0, $14404445c989d616$export$9a6a8fa585914167)(tasksList);
        });
        icon.addEventListener("keydown", (e)=>$684d38222e3cd930$var$assignKeyDownEvent(e));
    });
};
const $684d38222e3cd930$var$deleteEvents = ()=>{
    (0, $2ca1f701144f0151$export$867996ef69c16623)().forEach((icon)=>{
        icon.addEventListener("click", (e)=>{
            let activeCount = JSON.parse((0, $14404445c989d616$export$7a171f172be0782e)("activeCount"));
            let completedCount = JSON.parse((0, $14404445c989d616$export$7a171f172be0782e)("completedCount"));
            let tasksList = JSON.parse((0, $14404445c989d616$export$7a171f172be0782e)("tasksList"));
            const targetTask = tasksList.find((task)=>task.id === e.currentTarget.dataset.id);
            tasksList = tasksList.filter((task)=>task.id !== e.currentTarget.dataset.id);
            !targetTask.isCompleted && (0, $14404445c989d616$export$15d8621db9a88346)("activeCount", activeCount - 1);
            targetTask.isCompleted && (0, $14404445c989d616$export$15d8621db9a88346)("completedCount", completedCount - 1);
            (0, $14404445c989d616$export$15d8621db9a88346)("tasksList", tasksList);
            (0, $14404445c989d616$export$9a6a8fa585914167)(tasksList);
        });
        icon.addEventListener("keydown", (e)=>$684d38222e3cd930$var$assignKeyDownEvent(e));
    });
};
const $684d38222e3cd930$var$reorderList = ()=>{
    const listItems = [
        ...(0, $2ca1f701144f0151$export$4af0d615ab358e1)()
    ];
    const tasksList = JSON.parse((0, $14404445c989d616$export$7a171f172be0782e)("tasksList")) || [];
    const reorderedTasksList = tasksList.map((task)=>{
        for(let i = 0; i < listItems.length; i++){
            if (listItems[i].id === task.id) return {
                ...task,
                order: i
            };
        }
    });
    (0, $14404445c989d616$export$15d8621db9a88346)("tasksList", reorderedTasksList);
};
const $684d38222e3cd930$var$getAfterElemennt = (parent, yPosition)=>{
    const draggables = [
        ...parent.querySelectorAll(".todo__item:not(.todo__item--isDragging)")
    ];
    const targetElement = draggables.reduce((closest, draggable)=>{
        const box = draggable.getBoundingClientRect();
        const offset = yPosition - box.top - box.height / 2;
        if (offset < 0 && offset > closest.offset) return {
            offset: offset,
            element: draggable
        };
        else return closest;
    }, {
        offset: Number.NEGATIVE_INFINITY
    });
    return targetElement.element || null;
};
const $684d38222e3cd930$var$handleDragStart = (e)=>{
    e.currentTarget.classList.add("todo__item--isDragging");
};
const $684d38222e3cd930$var$handleDragEnd = (e)=>{
    e.currentTarget.classList.remove("todo__item--isDragging");
    $684d38222e3cd930$var$reorderList();
};
const $684d38222e3cd930$var$handleDragMove = (e)=>{
    const dragging = (0, $2ca1f701144f0151$export$5de1d99ba6724316).querySelector(".todo__item--isDragging");
    let yPosition;
    if (e.type === "dragover") yPosition = e.clientY;
    else if (e.type === "touchmove") yPosition = e.touches[0].clientY;
    const afterElement = $684d38222e3cd930$var$getAfterElemennt((0, $2ca1f701144f0151$export$5de1d99ba6724316), yPosition);
    if (afterElement === null) (0, $2ca1f701144f0151$export$5de1d99ba6724316).appendChild(dragging);
    else (0, $2ca1f701144f0151$export$5de1d99ba6724316).insertBefore(dragging, afterElement);
};
const $684d38222e3cd930$var$assignDragEvents = ()=>{
    (0, $2ca1f701144f0151$export$5de1d99ba6724316).addEventListener("dragover", (e)=>$684d38222e3cd930$var$handleDragMove(e));
    (0, $2ca1f701144f0151$export$4af0d615ab358e1)().forEach((item)=>{
        item.addEventListener("dragstart", (e)=>$684d38222e3cd930$var$handleDragStart(e));
        item.addEventListener("dragend", (e)=>$684d38222e3cd930$var$handleDragEnd(e));
    });
};
// drag and drop for touch screens
const $684d38222e3cd930$var$assignTouchEvents = ()=>{
    (0, $2ca1f701144f0151$export$5de1d99ba6724316).addEventListener("touchmove", (e)=>$684d38222e3cd930$var$handleDragMove(e), {
        passive: true
    });
    (0, $2ca1f701144f0151$export$4af0d615ab358e1)().forEach((item)=>{
        item.addEventListener("touchstart", (e)=>$684d38222e3cd930$var$handleDragStart(e), {
            passive: true
        });
        item.addEventListener("touchend", (e)=>$684d38222e3cd930$var$handleDragEnd(e));
    });
};
const $684d38222e3cd930$export$9ea2f0ccea903af3 = ()=>{
    $684d38222e3cd930$var$completeEvents();
    $684d38222e3cd930$var$deleteEvents();
    $684d38222e3cd930$var$assignDragEvents();
    $684d38222e3cd930$var$assignTouchEvents();
};
(0, $2ca1f701144f0151$export$f5e68c38e9e5defa).addEventListener("click", ()=>{
    (0, $2ca1f701144f0151$export$f5e68c38e9e5defa).classList.add("filter--isActive");
    (0, $2ca1f701144f0151$export$a23e3f5d5881010d).classList.remove("filter--isActive");
    (0, $2ca1f701144f0151$export$b0d7066fd38865c3).classList.remove("filter--isActive");
    let tasksList = JSON.parse((0, $14404445c989d616$export$7a171f172be0782e)("tasksList"));
    tasksList = tasksList.map((task)=>({
            ...task,
            hide: false,
            isDisplayAll: true
        }));
    (0, $14404445c989d616$export$15d8621db9a88346)("tasksList", tasksList);
    (0, $14404445c989d616$export$15d8621db9a88346)("currentDisplay", "all");
    (0, $14404445c989d616$export$9a6a8fa585914167)(tasksList);
});
(0, $2ca1f701144f0151$export$f5e68c38e9e5defa).addEventListener("keydown", (e)=>$684d38222e3cd930$var$assignKeyDownEvent(e));
(0, $2ca1f701144f0151$export$a23e3f5d5881010d).addEventListener("click", ()=>{
    (0, $2ca1f701144f0151$export$a23e3f5d5881010d).classList.add("filter--isActive");
    (0, $2ca1f701144f0151$export$f5e68c38e9e5defa).classList.remove("filter--isActive");
    (0, $2ca1f701144f0151$export$b0d7066fd38865c3).classList.remove("filter--isActive");
    let tasksList = JSON.parse((0, $14404445c989d616$export$7a171f172be0782e)("tasksList"));
    tasksList = tasksList.map((task)=>{
        if (task.isCompleted) return {
            ...task,
            hide: true,
            isDisplayAll: false
        };
        else return {
            ...task,
            hide: false,
            isDisplayAll: false
        };
    });
    (0, $14404445c989d616$export$15d8621db9a88346)("tasksList", tasksList);
    (0, $14404445c989d616$export$15d8621db9a88346)("currentDisplay", "active");
    (0, $14404445c989d616$export$9a6a8fa585914167)(tasksList);
});
(0, $2ca1f701144f0151$export$a23e3f5d5881010d).addEventListener("keydown", (e)=>$684d38222e3cd930$var$assignKeyDownEvent(e));
(0, $2ca1f701144f0151$export$b0d7066fd38865c3).addEventListener("click", ()=>{
    (0, $2ca1f701144f0151$export$b0d7066fd38865c3).classList.add("filter--isActive");
    (0, $2ca1f701144f0151$export$f5e68c38e9e5defa).classList.remove("filter--isActive");
    (0, $2ca1f701144f0151$export$a23e3f5d5881010d).classList.remove("filter--isActive");
    let tasksList = JSON.parse((0, $14404445c989d616$export$7a171f172be0782e)("tasksList"));
    tasksList = tasksList.map((task)=>{
        if (task.isCompleted) return {
            ...task,
            hide: false,
            isDisplayAll: false
        };
        else return {
            ...task,
            hide: true,
            isDisplayAll: false
        };
    });
    (0, $14404445c989d616$export$15d8621db9a88346)("tasksList", tasksList);
    (0, $14404445c989d616$export$15d8621db9a88346)("currentDisplay", "completed");
    (0, $14404445c989d616$export$9a6a8fa585914167)(tasksList);
});
(0, $2ca1f701144f0151$export$b0d7066fd38865c3).addEventListener("keydown", (e)=>$684d38222e3cd930$var$assignKeyDownEvent(e));
(0, $2ca1f701144f0151$export$846bb1a464a67773).addEventListener("click", ()=>{
    let tasksList = JSON.parse((0, $14404445c989d616$export$7a171f172be0782e)("tasksList"));
    tasksList = tasksList.filter((task)=>!task.isCompleted);
    (0, $14404445c989d616$export$15d8621db9a88346)("tasksList", tasksList);
    (0, $14404445c989d616$export$15d8621db9a88346)("completedCount", 0);
    (0, $2ca1f701144f0151$export$f5e68c38e9e5defa).click();
});
(0, $2ca1f701144f0151$export$846bb1a464a67773).addEventListener("keydown", (e)=>$684d38222e3cd930$var$assignKeyDownEvent(e));


const $14404445c989d616$var$addTaskToList = (task, checkIcon, crossIcon)=>{
    let listItem = document.createElement("li");
    listItem.classList.add("todo__item");
    task.hide && listItem.classList.add("todo__item--hide");
    listItem.setAttribute("id", task.id);
    listItem.setAttribute("draggable", true);
    listItem.innerHTML += `
    <div class="todo__task ${task.isCompleted ? " todo__task--isCompleted" : ""}">
      <div class="icon check__icon" data-id="${task.id}" role="button" tabindex="0">
        <img src="${checkIcon}" alt="check icon" />
      </div>
      <span>${task.value}</span>
    </div>
    <div class="delete__icon">
      <img src="${crossIcon}" alt="cross icon" class="icon cross__icon" data-id="${task.id}" role="button" tabindex="0" />
      <svg fill="#000000" width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M10,4A2,2,0,1,1,8,2,2,2,0,0,1,10,4ZM8,10a2,2,0,1,0,2,2A2,2,0,0,0,8,10Zm0,8a2,2,0,1,0,2,2A2,2,0,0,0,8,18ZM16,6a2,2,0,1,0-2-2A2,2,0,0,0,16,6Zm0,8a2,2,0,1,0-2-2A2,2,0,0,0,16,14Zm0,8a2,2,0,1,0-2-2A2,2,0,0,0,16,22Z"></path></g></svg>
    </div>
  `;
    (0, $2ca1f701144f0151$export$5de1d99ba6724316).appendChild(listItem);
};
const $14404445c989d616$export$7a171f172be0782e = (item)=>{
    return localStorage.getItem(item);
};
const $14404445c989d616$export$15d8621db9a88346 = (key, data)=>{
    localStorage.setItem(key, JSON.stringify(data));
};
const $14404445c989d616$export$1e81c9115b544420 = (task, tasksList)=>{
    tasksList.push(task);
    $14404445c989d616$export$15d8621db9a88346("tasksList", tasksList);
    return tasksList;
};
var $12db48e47c4459f0$exports = {};
$12db48e47c4459f0$exports = import.meta.resolve("dcXFW");


var $adffcd9f4e5009d3$exports = {};
$adffcd9f4e5009d3$exports = import.meta.resolve("3ymYn");


const $14404445c989d616$export$9a6a8fa585914167 = (data)=>{
    (0, $2ca1f701144f0151$export$5de1d99ba6724316).innerHTML = "";
    let currentDisplay = JSON.parse($14404445c989d616$export$7a171f172be0782e("currentDisplay")) || "all";
    const activeCount = JSON.parse($14404445c989d616$export$7a171f172be0782e("activeCount")) || 0;
    const completedCount = JSON.parse($14404445c989d616$export$7a171f172be0782e("completedCount")) || 0;
    if (data.length) {
        if (currentDisplay === "active" && activeCount === 0) {
            (0, $2ca1f701144f0151$export$5de1d99ba6724316).innerHTML = `<li class="todo__item">No Active Tasks (All Tasks Completed)</li>`;
            return;
        } else if (currentDisplay === "completed" && completedCount === 0) {
            (0, $2ca1f701144f0151$export$5de1d99ba6724316).innerHTML = `<li class="todo__item">No Completed Tasks (All Tasks Active)</li>`;
            return;
        } else {
            const checkIcon = new URL($12db48e47c4459f0$exports);
            const crossIcon = new URL($adffcd9f4e5009d3$exports);
            data.sort((a, b)=>a.order - b.order).forEach((item)=>$14404445c989d616$var$addTaskToList(item, checkIcon, crossIcon));
        }
    } else (0, $2ca1f701144f0151$export$5de1d99ba6724316).innerHTML += `<li class="todo__item">ToDo List Is Empty</li>`;
    (0, $2ca1f701144f0151$export$798c1b4704cda203).textContent = JSON.parse($14404445c989d616$export$7a171f172be0782e("activeCount")) || 0;
    (0, $684d38222e3cd930$export$9ea2f0ccea903af3)();
};
const $14404445c989d616$export$f543642fc33c1018 = ()=>(0, $2ca1f701144f0151$export$34e0f9847d4c02dd).classList.toggle("theme--isDark");
const $14404445c989d616$export$3e1c9c242083ed0 = ()=>{
    const tasksList = JSON.parse($14404445c989d616$export$7a171f172be0782e("tasksList")) || [];
    const isDarkTheme = JSON.parse($14404445c989d616$export$7a171f172be0782e("isDarkTheme"));
    isDarkTheme && $14404445c989d616$export$f543642fc33c1018();
    $14404445c989d616$export$9a6a8fa585914167(tasksList);
};


(0, $14404445c989d616$export$3e1c9c242083ed0)();


//# sourceMappingURL=repo.ba0ee73e.js.map
